const IDS_PER_CONTAINER = 1_000_000
const CONTAINER_BASE_NAME = 'drawtalk'

export const getIllustContainerName = (illustId: number | string) => {
  const index = Math.floor(Number(illustId) / IDS_PER_CONTAINER) + 1
  return index === 1 ? CONTAINER_BASE_NAME : `${CONTAINER_BASE_NAME}${index}`
}
